import { render, staticRenderFns } from "./OwnerAttributes.vue?vue&type=template&id=ba5d708e&scoped=true&"
import script from "./OwnerAttributes.vue?vue&type=script&lang=js&"
export * from "./OwnerAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5d708e",
  null
  
)

export default component.exports